.resizable-aside-panel-column {
    /* Do not set position here — Agent Home uses `fixed` via Tailwind; a CSS
       `position: relative` was winning the cascade and dumping the panel into
       the page flow under the home content instead of the right edge. */
    height: 100%;
    min-height: 0;
    flex-shrink: 0;
}

.resizable-aside-panel-column .react-resizable {
    position: relative;
    height: 100% !important;
    min-height: 0;
    overflow: visible;
}

.resizable-aside-panel-column .react-resizable-handle {
    position: absolute;
    z-index: 30;
    background: transparent;
    padding: 0;
    border: none;
    box-sizing: border-box;
    background-image: none;
}

.resizable-aside-panel-column .react-resizable-handle-w {
    top: 0 !important;
    left: 0 !important;
    right: auto !important;
    bottom: 0 !important;
    width: 12px !important;
    height: 100% !important;
    margin-top: 0 !important;
    margin-left: -6px !important;
    transform: none !important;
    cursor: col-resize;
}

.resizable-aside-panel-column__handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 12px;
    height: 100%;
    margin-left: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 2px solid transparent;
    pointer-events: auto;
}

.resizable-aside-panel-column__handle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ds-icon-subtle, #626f86);
    opacity: 0;
    pointer-events: none;
    transition: opacity 150ms ease;
    flex-shrink: 0;
}

.resizable-aside-panel-column__handle--active .resizable-aside-panel-column__handle-icon,
.resizable-aside-panel-column__handle:hover .resizable-aside-panel-column__handle-icon {
    opacity: 1;
}

.resizable-aside-panel-column__panel {
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    background: var(--ds-elevation-surface-current, #fff);
    transition: border-color 150ms ease;
}

.resizable-aside-panel-column .react-resizable:has(.resizable-aside-panel-column__handle:hover) .resizable-aside-panel-column__panel,
.resizable-aside-panel-column__panel--active {
    border-left-color: var(--ds-border-focused, #0c66e4) !important;
}
